import { IJobBoardSaveDTO, saveJobBoard } from 'wisestep-api';

import {
  publishEmailValues,
  publishJobBoardValues,
} from '../../../../features/jobs/publish/components/helper/jobBoardHelper';
import { failed, success } from '../../../../utils/NotificationMessages';

export const jobBoardSave: IJobBoardSaveDTO = {
  jobBoard: publishJobBoardValues,
  email: publishEmailValues,
};

export const sharedSuccess = () => success('Shared Successfully !!');
export const sharedFailed = () => failed('Error in sharing, Please try again !! ');

export const freeJobBoardSave = async () => {
  try {
    await saveJobBoard(jobBoardSave);
    return success(`Account Saved Successfully.`);
  } catch {
    return failed(`Error in saving account. Please try again.`);
  }
};

export const addAccountSuccess = () => success('Account has been saved Successfully !!');
export const addAccountFailed = () => failed('Error in saving account, Please try again !! ');

export const deleteAccountSuccess = () => success('Account has been deleted Successfully !!');

export const deleteAccountFailed = () =>
  failed('Incorrect Password. Enter correct password and try again.');

export const accountLimitMessage = () =>
  failed(
    'Maximum 10 Premium Job Board Accounts are allowed. Please delete any existing account and try again.'
  );

export const settingSuccess = () => success('Settings updated successfully. !!');
export const settingFailed = () => failed('Error in updating settings, Please try again !! ');

export const deleteSharedPostings = () =>
  success('Assigned Job Posting Credits Deleted Successfully!');
